import React from 'react'
import { useGetConnectionsQuery, useGetDashboardQuery } from '../../../../features/connections/connectionsApi'
import MetricValues from './MetricValues'

const Metrics = () => {
    const { data: connections = [] } = useGetConnectionsQuery()
    const { data: dashboard } = useGetDashboardQuery()

    if (connections.length === 0) {
        return null
    }

    const metrics = [
        { label: 'Connectors Used', count: connections.length },
        { label: 'Total Synced Records', count: dashboard ? dashboard.inboundCount + dashboard.outboundCount : 0 }
    ]

    return (
        <div className="row mb-3">
            {metrics.map((item) => <MetricValues key={item.label} label={item.label} count={item.count} />)}
        </div>
    )
}

export default Metrics
